export const contactUsReasons = [
  {
    value: 'General Inquiry',
    label: 'CU_LOCATOR'
  },
  {
    value: 'Other',
    label: 'CU_PROD_INFO'
  },
  {
    value: 'Parts Selection',
    label: 'CU_PARTS_INFO'
  },
  {
    value: 'Other',
    label: 'CU_QUOTE_PURCH'
  },
  {
    value: 'Other',
    label: 'CU_TRAINING'
  },
  {
    value: 'General Inquiry',
    label: 'CU_MERCHANDISE'
  },
  {
    value: 'Other',
    label: 'CU_MAINTENANCE'
  },
  {
    value: 'Website Support',
    label: 'CU_WEBSITE'
  },
  {
    value: 'Website Support',
    label: 'CU_TRANSALATIONS'
  },
  {
    value: 'Other',
    label: 'CU_OTHER'
  },
  {
    value: 'Other',
    label: 'SITE_ERROR_MESSAGING'
  }
];

export const askAnExpertReasons = [
  {
    label: 'EQUIPMENT_MANAGEMENT_SOLUTIONS'
  },
  {
    label: 'MAINTENANCE_SOLUTIONS'
  },
  {
    label: 'ENGINE_AND_DRIVETRAIN'
  },
  {
    label: 'GET'
  },
  {
    label: 'HYDRAULICS'
  },
  {
    label: 'SERVICES_POWER_SYSTEMS'
  },
  {
    label: 'UNDERCARRIAGE'
  },
  {
    label: 'CU_OTHER'
  }
];

export const japaneseLocaleCode = 'ja_JP';
export const finningUKDealerCode = 'M610';

export const ContactUsTabs = {
  CONTACT: 'contact',
  EXPERT: 'expert'
};

export const VARIANTS_MESSAGE_NOTIFICATION = {
  ERROR: 'error',
  SUCCESS: 'success'
};

export const STATIC_PHONE_NUMBER = '+1-888-228-1460';
